import {apolloClient} from '@/plugins/apollo'

export function getMutationName(mutation) {
    return mutation.definitions[0].selectionSet.selections[0].name.value
}

export function getErrorsByExcApolloExc(e) {
    let res = {nonFieldErrors: []}
    if (e.networkError && !e.networkError.statusCode)
        res.nonFieldErrors.push({code: 'network_error', message: 'Network error'})
    else
        res.nonFieldErrors.push({code: 'server_error', message: 'Server error'})

    // console.log(JSON.stringify(e))
    return res
}

export async function onSubmitHandler(componentScope, mutation,
                                      {
                                          // eslint-disable-next-line no-unused-vars
                                          setErrorsF = function (componentScope, errors) {
                                          },
                                          getMutationResF = (apollo_res, mutation) => apollo_res.data[getMutationName(mutation)],
                                          // eslint-disable-next-line no-unused-vars
                                          onSuccessF = function (componentScope, res) {
                                          },
                                          // eslint-disable-next-line no-unused-vars
                                          onFailF = function (componentScope) {
                                          },
                                          // eslint-disable-next-line no-unused-vars
                                          onStartF = function (componentScope) {
                                          },
                                          mutationVariables = {}

                                      } = {}) {

    if (!componentScope.graphqlLoadingFlag) {
        componentScope.graphqlLoadingFlag = true
        onStartF(componentScope)
        try {
            setErrorsF({}, componentScope)

            let apollo_res

            try {
                apollo_res = await apolloClient.mutate({
                    mutation,
                    variables: mutationVariables
                })
            } catch (e) {
                let errors = getErrorsByExcApolloExc(e)
                setErrorsF(errors, componentScope)
                throw e
            }

            let res = getMutationResF(apollo_res, mutation)
            setErrorsF(res['errors'], componentScope)
            if (res['success']) {
                onSuccessF(res, componentScope)
            } else {
                onFailF(componentScope)
            }
        } finally {
            componentScope.graphqlLoadingFlag = false
        }
    }
}

export const baseFieldNames = {
    nonFieldErrors: ''
}

export function getFieldName(fieldCode, fieldNames) {
    if (!fieldNames)
        fieldNames = baseFieldNames
    return (fieldCode in fieldNames) ? fieldNames[fieldCode] : fieldCode
}

export function getErrorMsg(errorCode, defaultErrorMsg, authErrorMessages) {
    if (authErrorMessages)
        return (errorCode in authErrorMessages) ? authErrorMessages[errorCode] : defaultErrorMsg
    else
        return defaultErrorMsg
}

export function getProcessedResponseErrorsFlat(rawResponseErrors, fieldNames, errorMessages) {
    let errors = []
    if (rawResponseErrors) {
        for (const [fieldCode, fieldErrors] of Object.entries(rawResponseErrors)) {
            for (const err of fieldErrors) {
                errors.push({
                    fieldName: getFieldName(fieldCode, fieldNames),
                    message: getErrorMsg(err.code, err.message, errorMessages)
                })
            }
        }
    }
    return errors
}

export function getProcessedResponseErrors(rawResponseErrors, fieldCodes, errorMessages) {
    let errors = {}

    for (const fieldCode of fieldCodes) {
        if (fieldCode === 'nonFieldErrors') {
            errors[fieldCode] = []
        } else {
            errors[fieldCode + 'InvalidFeedback'] = null
            errors[fieldCode + 'IsValid'] = null
        }
    }

    if (rawResponseErrors) {
        for (const [fieldCode, fieldErrors] of Object.entries(rawResponseErrors)) {
            if (fieldCode === 'nonFieldErrors') {
                for (const err of fieldErrors)
                    errors[fieldCode].push({message: getErrorMsg(err.code, err.message, errorMessages)})
            } else {
                let fieldErrorsMessages = []
                for (const err of fieldErrors)
                    fieldErrorsMessages.push(getErrorMsg(err.code, err.message, errorMessages))
                errors[fieldCode + 'InvalidFeedback'] = fieldErrorsMessages.join('\n')
                errors[fieldCode + 'IsValid'] = false
            }
        }
    }
    return errors
}